import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  observationEntry: {
    padding: 0,
    borderLeft: "none",
    width: "100%"
  }
});
